import type { MultipleOpportunity, SingleOpportunity } from '@swf/generated/types/api/sports';
import { notEmpty } from '@swf/sports/utils/notEmpty';

import type { BetSlipState } from '../../types/betSlip';

import { getIsAvailableOpportunity } from './getIsOpportunity';

export const generateAcceptedOdds = (
  acceptedOdds: BetSlipState['acceptedOdds'],
  opportunities: (SingleOpportunity | MultipleOpportunity)[]
): BetSlipState['acceptedOdds'] => ({
  ...acceptedOdds,
  ...opportunities.reduce<BetSlipState['acceptedOdds']>((acc, next) => {
    const acceptedOpportunityOdds = acceptedOdds[next.id];

    if (!notEmpty(acceptedOpportunityOdds)) {
      acc[next.id] = getIsAvailableOpportunity(next) ? next.winRunnerOdds : undefined;
    }

    return acc;
  }, {})
});
